import { resolveLocaleTag } from "./resolve";
import { FALLBACK_LOCALE } from "./locales";

export function formatDate(
  iso: string | Date,
  locale: string | null | undefined,
  options?: Intl.DateTimeFormatOptions,
): string {
  const date = typeof iso === "string" ? new Date(iso) : iso;
  const tag = resolveLocaleTag(locale);
  return date.toLocaleString(tag, options);
}

export function formatMoney(
  amount: number,
  currency: string,
  locale: string | null | undefined,
): string {
  const tag = resolveLocaleTag(locale);
  try {
    return new Intl.NumberFormat(tag, {
      style: "currency",
      currency: currency.toUpperCase(),
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency.toUpperCase()}`;
  }
}

export function formatRelativeTime(
  iso: string | Date,
  locale: string | null | undefined,
  now: Date = new Date(),
): string {
  const date = typeof iso === "string" ? new Date(iso) : iso;
  const tag = resolveLocaleTag(locale);
  const diffMs = date.getTime() - now.getTime();
  const diffSec = Math.round(diffMs / 1000);
  const absSec = Math.abs(diffSec);

  const rtf = new Intl.RelativeTimeFormat(tag, { numeric: "auto" });

  if (absSec < 60) {
    return rtf.format(diffSec, "second");
  }
  const diffMin = Math.round(diffSec / 60);
  if (Math.abs(diffMin) < 60) {
    return rtf.format(diffMin, "minute");
  }
  const diffHour = Math.round(diffMin / 60);
  if (Math.abs(diffHour) < 24) {
    return rtf.format(diffHour, "hour");
  }
  const diffDay = Math.round(diffHour / 24);
  if (Math.abs(diffDay) < 30) {
    return rtf.format(diffDay, "day");
  }
  const diffMonth = Math.round(diffDay / 30);
  if (Math.abs(diffMonth) < 12) {
    return rtf.format(diffMonth, "month");
  }
  const diffYear = Math.round(diffMonth / 12);
  return rtf.format(diffYear, "year");
}

export { FALLBACK_LOCALE };
